import { isURL, getRootDomain } from '../url'

const getAuth0 = (): Auth0Client => window.__auth0__ || window.auth0
export default getAuth0

function getContinueTo(searchParams: URLSearchParams, browseUrl: string): string {
  const continueTo = searchParams.get('continueTo') || document.referrer

  if (continueTo?.startsWith('/')) return new URL(continueTo, browseUrl).href
  if (continueTo === '' || !isURL(continueTo)) return browseUrl
  const url = new URL(continueTo)
  if (getRootDomain(url) === getRootDomain(new URL(browseUrl))) return url.href
  return browseUrl
}

export function getBrowseRedirectUri(searchParams: URLSearchParams): string {
  const browseUrl = window.location.origin
  const continueTo = getContinueTo(searchParams, browseUrl)
  return `${browseUrl}/sso/browse/callback?continueTo=${encodeURIComponent(continueTo)}`
}
